export default __webpack_public_path__ + "static/media/trash-outline-green.9638defd.svg";